import _ from "lodash";
import React, { useState, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { CloseOutlined, SearchOutlined } from "@toddle-edu/ds-icons";
import { TextInput } from "@toddle-edu/ds-web";

import { useI18n } from "Hooks";

import classes from "./SearchInput.scss";

const SearchInput = props => {
  const { t } = useI18n(["common"]);

  const {
    searchText = "",
    updateSearchText = () => {},
    showLeadingIcon,
    placeholder = t("common:search"),
    onFocus,
    overrideClasses = {},
  } = props;

  const [searchValue, setSearchValue] = useState(searchText);

  const debouncedUpdateSearch = useCallback(_.debounce(updateSearchText, 500), [
    updateSearchText,
  ]);

  useEffect(() => {
    setSearchValue(searchText);
  }, [searchText]);

  const onSearchTextChange = event => {
    const value = _.get(event, "target.value", "");
    setSearchValue(value);
    debouncedUpdateSearch(value);
  };

  const clearSearch = () => {
    setSearchValue("");
    updateSearchText("");
  };

  const showTrailingIcon = _.size(searchValue) > 0;
  const handleFocus = _.isFunction(onFocus) ? onFocus : _.noop;
  return (
    <div
      className={classNames(
        classes.searchContainer,
        overrideClasses.searchContainer
      )}
    >
      <TextInput
        autoFocus
        onFocus={handleFocus}
        value={searchValue}
        onChange={onSearchTextChange}
        placeholder={placeholder}
        onTrailingIconClick={clearSearch}
        leadingIcon={showLeadingIcon ? <SearchOutlined /> : null}
        trailingIcon={showTrailingIcon ? <CloseOutlined /> : null}
        size="large"
      />
    </div>
  );
};

SearchInput.propTypes = {
  searchText: PropTypes.string,
  placeholder: PropTypes.string,
  updateSearchText: PropTypes.func,
};

export default SearchInput;
